import { SportsWithPhotos } from '../constants';

const getSportColorKey = (
    sportId: number,
    subDiscipline?: string
): string => {
    if (!subDiscipline) {
        return String(sportId);
    }

    return `${sportId}-${subDiscipline}`;
};

const getSportColorClass = (
    sportId: number,
    subDiscipline?: string
): string => {
    const key = getSportColorKey(sportId, subDiscipline);

    return `sport-color-${key}`;
}

const checkLogoIsPhoto = (
    sportId: number,
    _subDiscipline?: string
): boolean => {
    // TODO:
    // существует ненулевая вероятность, что в некоторых дисциплинах киберспорта также будут приходить фотки
    // логика "subDiscipline" оставлена тут для этого случая, чтобы потом не бегать не исправлять везде
    // сигнатуру функций в этом файле желательно поддерживать одинаковую, чтобы сразу покрывать все случаи 
    // const key = getSportColorKey(sportId, subDiscipline);

    return SportsWithPhotos.has(sportId);
}


export {
    getSportColorKey,
    getSportColorClass,
    checkLogoIsPhoto,
}
